    <div class="camera-container">
      <!-- Header Section -->
      <header class="camera-header">
        <div class="header-left">
          <h1>Camera View</h1>
          <p class="subtitle-text">Live camera feed monitoring.</p>
        </div>
        <div class="header-right">
          <button class="btn-generate-link" (click)="generatePublicLink()">
            <i class="pi pi-share-alt"></i>
            Generate Public Streaming Link
          </button>
        </div>
      </header>

      <!-- Camera View Section -->
      <main class="camera-content">
        <section class="camera-view">
            <p class="h6" style="padding-left: 15px;">Camera 1</p>

          <iframe 
            allow="fullscreen" 
            height="100%" 
            style="height: 500px;" 
            width="100%" 
            [src]="cameraUrl">
          </iframe>
          <p class="h6" style="padding-left: 15px;">Camera 2</p>
          <iframe allow="fullscreen" height="100%"  style="height: 500px;" width="100%" src="https://console.rhombussystems.com/share/live/CQ_B5KSISw-VLTyW0eh03Q"></iframe>
        </section>
      </main>
    </div>

